import React, { PropsWithChildren, createContext, useContext, useMemo, useState } from 'react'
import { AIActions, ActionType } from '../types'
import { actions } from '../actions'
import { assistants } from '../assistants'

const DEFAULT_FUNCTION = () => {}

type AIState = {
  page: AIActions | undefined
  selectedAction: ActionType | undefined
  selectedAssistant: ActionType | undefined
  setPage: React.Dispatch<React.SetStateAction<AIActions | undefined>>
  shuffled: boolean
  setShuffled: (shuffled: boolean) => void
  data?: string
  setData: React.Dispatch<React.SetStateAction<string | undefined>>
  assistantId?: string
}

export const AIContext = createContext<AIState>({
  page: undefined,
  selectedAction: undefined,
  selectedAssistant: undefined,
  setPage: DEFAULT_FUNCTION,
  shuffled: false,
  setShuffled: DEFAULT_FUNCTION,
  data: undefined,
  setData: DEFAULT_FUNCTION,
  assistantId: undefined,
})

export const useAIContext = () => useContext(AIContext)

export const AIProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [page, setPage] = useState<AIActions>()
  const [shuffled, setShuffled] = useState(false)
  const [data, setData] = useState<string>()

  const selectedAction = useMemo(() => actions.find((action) => action.action === page), [page])
  const selectedAssistant = useMemo(
    () => assistants.find((action) => action.action === page),
    [page],
  )

  const assistantId = selectedAssistant?.assistantId

  return (
    <AIContext.Provider
      value={{
        page,
        setPage,
        selectedAction,
        selectedAssistant,
        shuffled,
        setShuffled,
        data,
        setData,
        assistantId,
      }}
    >
      {children}
    </AIContext.Provider>
  )
}
